import { render } from "./ApDate.vue?vue&type=template&id=670a62be&ts=true"
import script from "./ApDate.vue?vue&type=script&lang=ts"
export * from "./ApDate.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__